import { hostUrlConverter } from '../../../../util';

export const AdsBannerCardButtons = ({ productURL, productButtonName, contentType, googleAnalytics }) => {
    const learnMoreURL = 'yearbooks/students-and-parents/yearbook-ads'

    return (
        <div>
            <span className="my-3 d-inline-block">
                <a href={hostUrlConverter(productURL)} 
                    className="jos-ga-tracking-element ads-button btn"
                    data-jos-ga-tracking={JSON.stringify({
                        _resolveFields: {
                            businessUnit: { 
                                catalogOsr: googleAnalytics?.catalogOSR
                            },
                            productLine: { 
                                catalogOsr: googleAnalytics?.catalogOSR 
                            }
                        },
                        clickText: productButtonName, 
                        modalType: '', 
                        itemName: productButtonName,
                        actionType: 'button_click', 
                        categoryName: '',
                        contentName: productButtonName,
                        contentType
                    })}
                >{productButtonName}</a>
            </span>
            <span className="learnmore-button">
                <a href={hostUrlConverter(learnMoreURL)} 
                    className="jos-ga-tracking-element ads-button btn"
                    data-jos-ga-tracking={JSON.stringify({
                        _resolveFields: {
                            businessUnit: { 
                                catalogOsr: googleAnalytics?.catalogOSR
                            },
                            productLine: { 
                                catalogOsr: googleAnalytics?.catalogOSR 
                            }
                        },
                        clickText: 'Learn More', 
                        modalType: '', 
                        itemName: productButtonName,
                        actionType: 'button_click', 
                        categoryName: '',
                        contentName: productButtonName,
                        contentType
                    })}
                >Learn More</a>
            </span>
        </div>
    )
}